import type React from "react";
import { ReactComponent as Svg } from "./assets/casino.svg";
import * as styles from "./Icon.module.scss";

type CasinoProps = React.SVGProps<SVGSVGElement>;

export const Casino = ({ className, ...props }: CasinoProps) => (
  <Svg className={className ?? styles.base} {...props} />
);